<!-- =========================================================================================
  File Name: UserList.vue
  Description: Module Fields List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">

    <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="invalidLayout">
      <span>{{ $t("MODULES.InvalidLayoutWarning") }}</span>
    </vs-alert>

    <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="unsavedLayout">
      <span>{{ $t("MODULES.UnsavedChangesWarning") }}</span>
    </vs-alert>

    <vs-popup id="select-color" :title="$t('MODULES.SelectStatusColor')" :active.sync="showEditColorsOptionModal">
      <div class="vx-row">
        <div class="vx-col w-full mt-2" style="margin-bottom: 50px!important;">
          <label class="vs-input--label">{{ $t("MODULES.color") }}</label>
          <v-select class="icon-select" v-model="colorOption" :options="colorOptions" label="name">
            <template v-slot:option="option">
              <div :class="'con-vs-chip vs-chip-' + option.color + ' con-color mr-4'
                " style="color: rgba(255, 255, 255, 0.9);">
                <span class="text-chip vs-chip--text"></span>
              </div>
              {{ option.name }}
            </template>
          </v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:1/2 w-full mt-2">
          <vs-button class="ml-auto mt-2" @click="showEditColorsOptionModal = false">{{ $t("MODULES.confirm")
          }}</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="$t('MODULES.AddBlock')" :active.sync="addBlockPopUpActive">
      <div class="vx-row" id="add-block">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
          <vs-input :label="$t('MODULES.blockName')" v-model="blockAddDataObject.title" class="w-full" type="text"
            name="block-title" />
        </div>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.collapsed") }}</label>
            <vs-switch v-model="blockAddDataObject.collapsed" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.visible") }}</label>
            <vs-switch v-model="blockAddDataObject.visible" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.showOnAdd") }}</label>
            <vs-switch v-model="blockAddDataObject.showOnAdd" class="mt-1 ml-1" />
          </li>
        </ul>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">{{
            $t("MODULES.dependentOnList")
            }}</label>
          <v-select v-model="blockAddDataObject.relatedPicklist" class="field-type-select" :clearable="true"
            :disabled="picklistFields.length === 0" :options="picklistFields" @input="onPicklistFieldChange('add')"
            label="name" name="related-picklist" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">{{
            $t("MODULES.dependentOnItem")
            }}</label>
          <v-select v-model="blockAddDataObject.relatedPicklistItem" class="field-type-select" :disabled="blockAddDataObject.relatedPicklist === null ||
            JSON.stringify(blockAddDataObject.relatedPicklist) === '{}'
            " :clearable="true" :options="blockAddDataObject.relatedPicklist === null ||
              JSON.stringify(blockAddDataObject.relatedPicklist) === '{}'
              ? []
              : picklistFieldItems[blockAddDataObject.relatedPicklist.hash]
              " label="name" name="related-picklist-item" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">{{
            $t("MODULES.blockContentType")
            }}</label>
          <v-select v-model="blockAddDataObject.contentType" :clearable="false"
            :options="blockAddDataObject.blockContentTypeOptions" name="block-content-type"
            :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
        <div class="vx-col md:w-1/2 w-full" v-show="blockAddDataObject.contentType.value && blockAddDataObject.contentType.value === 'embbeded'">
          <!-- <label class="vs-input--label">URL</label> -->
          <vs-input label="URL" v-model="blockAddDataObject.contentUrl" class="w-full" type="text" name="block-content-url" />
        </div>
      </div>
      <div class="vx-row mt-2" v-show="blockAddDataObject.contentType.value && blockAddDataObject.contentType.value === 'embbeded'">
        <div class="vx-col w-full">
          <ul class="switch-container">
            <li>
              <label class="vs-input--label">{{ $t("MODULES.requireIframeSubmitReady") }}</label>
              <vs-switch v-model="blockAddDataObject.requireIframeSubmitReady" class="mt-1 ml-1" />
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <label class="vs-input--label">Exibir bloco para as roles (deixe vazio para todas)</label>
          <v-select multiple v-model="blockAddDataObject.roles" :options="roleList" label="name" :reduce="r => r.hash" :closeOnSelect="false" placeholder="Selecione as roles..." name="block-roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>

      <div class="vx-row"><br /></div>
      <div class="vx-row"><br /></div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
          <vs-button class="ml-auto mt-2" @click="addBlock">{{
            $t("MODULES.submit")
            }}</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="edit-block" :title="$t('MODULES.editBlock')" :active.sync="onChangeEditBlockPopUp">
      <div class="vx-row" id="edit-block">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
          <vs-input :label="$t('MODULES.blockName')" v-model="blockEditDataObject.title" class="w-full" type="text"
            name="block-title-edit" />
        </div>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.collapsed") }}</label>
            <vs-switch v-model="blockEditDataObject.collapsed" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.visible") }}</label>
            <vs-switch v-model="blockEditDataObject.visible" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.showOnAdd") }}</label>
            <vs-switch v-model="blockEditDataObject.showOnAdd" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3" v-if="blockEditDataObject.hash && blockObject[blockEditDataObject.hash] && blockObject[blockEditDataObject.hash].contentType === 'embbeded'">
          <li>
            <label class="vs-input--label">{{ $t("MODULES.requireIframeSubmitReady") }}</label>
            <vs-switch v-model="blockEditDataObject.requireIframeSubmitReady" class="mt-1 ml-1" />
          </li>
        </ul>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">{{
            $t("MODULES.dependentOnList")
            }}</label>
          <v-select multiple v-model="blockEditDataObject.relatedPicklist" class="field-type-select" :clearable="true"
            :disabled="picklistFields.length === 0" :options="picklistFields" @input="onPicklistFieldChange('edit')"
            label="name" name="related-picklist" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">{{
            $t("MODULES.dependentOnItem")
            }}</label>
          <v-select multiple v-model="blockEditDataObject.relatedPicklistItem" class="field-type-select" :disabled="blockEditDataObject.relatedPicklist === null ||
            JSON.stringify(blockEditDataObject.relatedPicklist) === '{}'
            " :clearable="true" :options="serializeBlockPicklistFieldItems(blockEditDataObject.relatedPicklist)" label="name" name="related-picklist-item" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <label class="vs-input--label">Exibir bloco para as roles (deixe vazio para todas)</label>
          <v-select multiple v-model="blockEditDataObject.roles" :options="roleList" label="name" :reduce="r => r.hash" :closeOnSelect="false" placeholder="Selecione as roles..." name="block-roles-edit" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>

      <div class="vx-row"><br /></div>
      <div class="vx-row"><br /></div>
    </vs-popup>

    <!-- <add-module-field-modal/> -->

    <vs-popup id="add-field" :title="$t('MODULES.AddField')" :active.sync="addFieldPopUpActive">
      <add-module-field-modal :addFieldPopUpActive="addFieldPopUpActive" :fieldData="fieldData"
        :rolePermissions="rolePermissions" :roleListSliced="roleListSliced"
        :currentBlockToAddField="currentBlockToAddField" @reset-props="resetAddModuleFieldProps" />
    </vs-popup>

    <vs-popup id="update-field" :title="$t('MODULES.editField')" :active.sync="editFieldPopUpActive">
      <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" :finishButtonText="$t('MODULES.submit')"
        @on-complete="editFormSubmitted">
        <tab-content :title="$t('MODULES.basic_data')" class="mb-5" :before-change="validateStep1Edit">
          <!-- tab 1 content -->
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{ $t("MODULES.type") }}</label>
              <v-select v-model="fieldEditData.type" disabled class="field-type-select" :clearable="false"
                @input="onFieldEditTypeChange" :options="fieldEditData.typeOptions" label="name" name="columnsOnForm"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.columns_in_form")
                }}</label>
              <v-select v-model="fieldEditData.columnsOnForm" :disabled="disableColumnsOnForm" :clearable="false"
                :options="fieldEditData.columnsOnFormOptions" name="columnsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="name" v-model="fieldEditData.name" class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input :label="$t('MODULES.legend')" v-model="fieldEditData.subtitle" class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.showHint")
                    }}</label>
                  <vs-switch v-model="fieldEditData.showHint" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.showHint">
              <vs-input type="email" label="Dica" v-model="fieldEditData.hint" class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 31">
              <label class="vs-input--label">{{
                $t("MODULES.rowsInForm")
                }}</label>
              <v-select v-model="fieldEditData.rowsOnForm" :clearable="false" :options="fieldEditData.rowsOnFormOptions"
                name="rowsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="fieldEditData.disableAll" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5"></div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5"></div>
          </div>
        </tab-content>

        <tab-content :title="$t('MODULES.general')" class="mb-5" :before-change="validateStep2Edit">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.dependentOnList")
                }}</label>
              <v-select v-model="fieldEditData.picklistField" class="field-type-select" :clearable="true"
                :disabled="fieldEditData.picklistFieldOptions.length === 0"
                :options="fieldEditData.picklistFieldOptions" label="name" name="list" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.dependentOnItem")
                }}</label>
              <v-select v-model="fieldEditData.picklistItem" class="field-type-select" :disabled="fieldEditData.picklistField === null ||
                JSON.stringify(fieldEditData.picklistField) === '{}'
                " :clearable="true" :options="fieldEditData.picklistField === null ||
                  JSON.stringify(fieldEditData.picklistField) === '{}'
                  ? []
                  : fieldEditData.picklistFieldItemsOptions[
                  fieldEditData.picklistField.hash
                  ]
                  " label="name" name="related-module-field" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-row mt-2" v-if="fieldEditData.type.id === 25 || fieldEditData.type.id === 33">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.relatedToModule")
                }}</label>
              <v-select v-model="fieldEditData.relatedModule" class="field-type-select" :clearable="false"
                :options="fieldEditData.moduleOptions" @input="onRelatedModuleEditChange" label="name"
                name="related-module" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.relatedToField")
                }}</label>
              <v-select v-model="fieldEditData.relatedField" class="field-type-select" :clearable="false"
                :options="fieldEditData.moduleFieldOptions" label="name" name="related-module-field"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>


            <div class="vx-col mt-3 md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.dependsOnField")
                }}</label>
              <v-select v-model="fieldEditData.dependentField" class="field-type-select" :clearable="true"
                :options="fieldEditData.relatedFieldOptions" label="name" name="related-module-field"
                :disabled="fieldEditData.dependentDisable" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>

          <div class="vx-row" v-if="fieldEditData.type.id === 30">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.relatedToKanban")
                }}</label>
              <v-select v-model="fieldEditData.relatedKanban" class="field-type-select" :clearable="false"
                :options="fieldEditData.moduleOptions.filter(x => x.type === 6)" label="name" name="related-kanban"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>

          <div class="vx-row mt-3" v-if="fieldEditData.type.id === 30 &&
            JSON.stringify(fieldEditData.relatedKanban) !== '{}'
          ">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.selectTitleFieldInKanban")
                }}</label>
              <v-select v-model="fieldEditData.kanbanTitle" class="field-type-select" :clearable="false"
                :options="fieldsListToKanban" label="name" name="related-kanban" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.selectDescriptionFieldInKanban")
                }}</label>
              <v-select v-model="fieldEditData.kanbanDescription" class="field-type-select" :clearable="false"
                :options="fieldsListToKanban" label="name" name="related-kanban" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>

          <div class="vx-row" v-if="fieldEditData.type.id == 24">
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
              <vx-input-group class="mb-base mt-5">
                <vs-input v-model="editOptionValue" maxlength="100" @keypress.enter="addOptionEditForm" />
                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                      @click="addOptionEditForm"></vs-button>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
              <draggable :list="fieldEditData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
                class="p-2 cursor-move">
                <vs-chip color="primary"
                  style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                  v-for="(listItem, index) in fieldEditData.options" :key="index">
                  <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                    @click="removeItemEditForm(index)"
                    style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                  {{ listItem }}
                </vs-chip>
              </draggable>
            </div>
          </div>
          <div class="vx-row mt-3" v-if="fieldEditData.type.id === 28">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.selectFieldForDocumentName")
                }}</label>
              <v-select v-model="fieldEditData.documentNameField" class="field-type-select" :clearable="false"
                :options="fieldsListToDocumentName" label="name" name="related-document-name"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-row" v-if="fieldEditData.type.id == 32">
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
              <vx-input-group class="mb-base mt-5">
                <vs-input v-model="editOptionValue" maxlength="100" @keypress.enter="addOptionEditForm" />
                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                      @click="addOptionEditForm"></vs-button>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
              <draggable :list="fieldEditData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
                class="p-2 cursor-move">
                <vs-chip color="primary"
                  style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                  v-for="(listItem, index) in fieldEditData.options" :key="index">
                  <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                    @click="removeItemEditForm(index)"
                    style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                  {{ listItem }}
                </vs-chip>
              </draggable>
            </div>
          </div>
          <div class="vx-row" v-if="fieldEditData.type.id == 29">
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.insertItem") }}</h6>
              <vx-input-group class="mb-base mt-5">
                <vs-input v-model="editOptionValue" maxlength="100" @keypress.enter="addOptionEditForm(29)" />
                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                      @click="addOptionEditForm(29)"></vs-button>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <h6 class="mt-5 mb-3">{{ $t("MODULES.ItemsInList") }}</h6>
              <draggable :list="fieldEditData.options" :group="{ name: 'tags', pull: 'clone', put: false }"
                class="p-2 cursor-move">
                <vs-chip :color="listItem.color || 'primary'"
                  style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
                  v-for="(listItem, index) in fieldEditData.options" :key="index">
                  <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3"
                    @click="removeItemEditForm(index)"
                    style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon>
                  {{ listItem.value }}
                </vs-chip>
              </draggable>
            </div>
          </div>
          <div class="vx-row" v-if="fieldEditData.type.id == 24 || fieldEditData.type.id == 29">
            <div class="vx-col md:w-1/2 w-full">
              <label class="vs-input--label">{{
                $t("MODULES.defaultValue")
                }}</label>
              <v-select v-model="fieldEditData.defaultValue" :clearable="true" :options="fieldEditData.options"
                label="value" name="default-value" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5" v-if="showPlaceholder.includes(fieldEditData.type.id)">
              <vs-input type="text" label="Placeholder" v-model="fieldEditData.placeholder" class="w-full" />
            </div>
            <div class="vx-col mt-5" v-if="fieldEditData.type.id === 20 || fieldEditData.type.id === 18
            ">
              <label class="vs-input--label">
                {{ $t("MODULES.decimalPlaces") }}
              </label>
              <vs-input-number v-model="fieldEditData.decimals" min="1" max="6" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-if="fieldEditData.type.id === 1 ||
              fieldEditData.type.id === 2 ||
              fieldEditData.type.id === 3 ||
              fieldEditData.type.id === 16 ||
              fieldEditData.type.id === 19 ||
              fieldEditData.type.id === 23
            ">
              <vs-input type="text" v-if="fieldEditData.type.id === 1 ||
                fieldEditData.type.id === 2 ||
                fieldEditData.type.id === 3 ||
                fieldEditData.type.id === 16 ||
                fieldEditData.type.id === 19
              " label="Valor Padrão" v-model="fieldEditData.defaultValue" class="w-full" />
              <ul class="switch-container" v-else-if="fieldEditData.type.id === 23">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.defaultValue")
                    }}</label>
                  <vs-switch v-model="fieldEditData.defaultValue" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldEditData.type.id)">
              <vs-input type="number" :label="$t('MODULES.minValue')" v-model="fieldEditData.minValueInt"
                class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldEditData.type.id)">
              <vs-input type="number" :label="$t('MODULES.maxValue')" v-model="fieldEditData.maxValueInt"
                class="w-full" />
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldEditData.type.id)">
              <label class="vs-input--label">
                {{ $t("MODULES.minValue") }}
              </label>
              <flat-pickr v-model="fieldEditData.minValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                name="dob" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldEditData.type.id)">
              <label class="vs-input--label">
                {{ $t("MODULES.maxValue") }}
              </label>
              <flat-pickr v-model="fieldEditData.maxValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                name="dob" />
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldEditData.type.id)
              ">
              <label class="vs-input--label">
                {{ $t("MODULES.minValue") }}
              </label>
              <flat-pickr v-model="fieldEditData.minValueDateTime" :config="{
                dateFormat: 'd/m/Y H:i:S',
                enableTime: true,
                enableSeconds: true,
                time_24hr: true
              }" class="w-full" name="dob" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldEditData.type.id)
              ">
              <label class="vs-input--label">
                {{ $t("MODULES.maxValue") }}
              </label>
              <flat-pickr v-model="fieldEditData.maxValueDateTime" :config="{
                dateFormat: 'd/m/Y H:i:S',
                enableTime: true,
                enableSeconds: true,
                time_24hr: true
              }" class="w-full" name="dob" />
            </div>

            <!-- Min and Max Value -->
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 1">
              <!-- <vs-input
                type="text"
                :label="$t('MODULES.mask')"
                v-model="fieldEditData.mask"
                class="w-full"
              /> -->

              <label class="vs-input--label">
                {{ $t('MODULES.mask') }}
              </label>
              <v-select v-model="fieldEditData.mask" multiple taggable push-tags />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.saveMask")
                    }}</label>
                  <vs-switch v-model="fieldEditData.saveMask" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showLengthField.includes(fieldEditData.type.id)">
              <vs-input type="number" :label="$t('MODULES.size')" v-model="fieldEditData.length" class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5"></div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="(fieldEditData.type.id >= 4 && fieldEditData.type.id <= 15) ||
              (fieldEditData.type.id >= 17 && fieldEditData.type.id <= 19)
              "></div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 25">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.showRelatedTab")
                    }}</label>
                  <vs-switch v-model="fieldEditData.relatedTab" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 25 && fieldEditData.showRelatedTabName
              ">
              <vs-input type="text" :label="$t('MODULES.tabName')" v-model="fieldEditData.relatedTabName"
                class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 25 && fieldEditData.showRelatedTabName
              ">
              <vs-input type="text" :label="$t('MODULES.tabNameEn')" v-model="fieldEditData.relatedTabNameEn"
                class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 25 && fieldEditData.relatedTab">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.customDisplay")
                    }}</label>
                  <vs-switch v-model="fieldEditData.customDisplay" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.customDisplay">
              <label class="vs-input--label">{{
                $t("MODULES.customDisplayLocation")
                }}</label>
              <v-select v-model="fieldEditData.displayLocation" :clearable="false" :options="moduleTabBlocks"
                name="default-value" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 30">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.showFooter")
                    }}</label>
                  <vs-switch v-model="fieldEditData.showFooter" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideQuickCreate.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.quickCreation")
                    }}</label>
                  <vs-switch v-model="fieldEditData.quickCreate" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideMassEdit.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.massEdit")
                    }}</label>
                  <vs-switch v-model="fieldEditData.massEdit" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideCallApi.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{ $t("MODULES.performApiQuery") }}</label>
                  <vs-switch v-model="fieldEditData.callApi" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col mt-5" v-show="fieldEditData.callApi">
              <label class="vs-input--label">{{
                $t("MODULES.maxTimeout")
                }}</label>
              <vs-input-number v-model="fieldEditData.minimalTimeout" min="3" max="60" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5"
              v-show="(fieldEditData.type.id >= 3 && fieldEditData.type.id <= 18) || fieldData.type.id === 35">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.ShowIcon")
                    }}</label>
                  <vs-switch v-model="fieldEditData.showIcon" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.mandatory")
                    }}</label>
                  <vs-switch v-model="fieldEditData.mandatory" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.fullLine")
                    }}</label>
                  <vs-switch v-model="fieldEditData.entireLine" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideUnique.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.uniqueValue")
                    }}</label>
                  <vs-switch v-model="fieldEditData.unique" class="mt-1 ml-1" disabled />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="showSecretField.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.secret")
                    }}</label>
                  <vs-switch v-model="fieldEditData.secret" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!hideDisabled.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.disabled")
                    }}</label>
                  <vs-switch v-model="fieldEditData.isDisabled" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="!unavailableSearchTypes.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.enableSearch")
                    }}</label>
                  <vs-switch v-model="fieldEditData.isSearchField" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="availableConcatIdentifierTypes.includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.concatIdentifier")
                    }}</label>
                  <vs-switch v-model="fieldEditData.concatIdentifier" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="[12, 13, 35].includes(fieldEditData.type.id)">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.allowPastDates")
                    }}</label>
                  <vs-switch v-model="fieldEditData.allowPastDates" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 16">
              <ul class="switch-container">
                <li>
                  <label class="vs-input--label">{{
                    $t("MODULES.showProgressBar")
                    }}</label>
                  <vs-switch v-model="fieldEditData.showProgressBar" class="mt-1 ml-1" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5"></div>
            <div class="vx-col md:w-1/2 w-full mt-5"></div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Permissões" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Selecione a permissão do campo nos cargos</span>
              </div>
              <div style="float: right;">
                <div style="float: left; margin-right: 12px;">
                  <div style="float: left; margin-right: 6px;">
                    <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-dark']" />
                  </div>
                  <div style="float: left;">
                    <span>{{ $t("MODULES.hidden") }}</span>
                  </div>
                </div>
                <div style="float: left; margin-right: 12px;">
                  <div style="float: left; margin-right: 6px;">
                    <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-primary']" />
                  </div>
                  <div style="float: left;">
                    <span>{{ $t("MODULES.readOnly") }}</span>
                  </div>
                </div>
                <div style="float: left; margin-right: 12px;">
                  <div style="float: left; margin-right: 6px;">
                    <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-success']" />
                  </div>
                  <div style="float: left;">
                    <span>{{ $t("MODULES.write") }}</span>
                  </div>
                </div>
              </div>
              <vs-divider />
            </div>
          </div>
          <vs-table :data="roleListSlicedEdit">
            <template>
              <vs-tr v-for="roleItem in roleListSlicedEdit" :key="roleItem.hash">
                <vs-td v-for="role in roleItem" :key="role.hash" style="width: 33.3%!important;">
                  <label class="vs-input--label" style="font-size: 14px;">{{
                    role.name
                    }}</label>
                  <div>
                    <div>
                      <vs-slider max="2" :id="`slider-edit-${role.hash}`" v-model="rolePermissionsEdit[role.hash]"
                        @input="sliderEditChange(`${role.hash}`, $event)"
                        style="width: 12% !important; min-width: 0px !important; float: left;" />
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </tab-content>
      </form-wizard>
    </vs-popup>

    <!-- <vs-button class="mb-3 ml-auto md:block" @click="addBlockCall"> Adicionar Bloco</vs-button> -->

    <vs-button class="mb-3 ml-auto " @click="addBlockCall" color="primary" type="filled" icon-pack="feather"
      icon="icon-plus-circle">{{ $t("MODULES.AddBlock") }}</vs-button>

    <vx-card v-if="moduleColumnsOnForm" :title="$t('MODULES.module') + ' ' + this.moduleInfo['name']" save-layout
      :save-layout-disabled="invalidLayout" @saveLayoutClicked="updateLayout">
      <draggable class="cursor-move mt-3" group="cards" :animation="700" draggable=".is-card">
        <vx-card :title="blockObject[block.hash].title" class="mt-3 is-card is-block" v-for="block in blockData"
          :key="block.hash" :id="'block-' + block.hash" @dragover.prevent @drop="dropItem" :add-action="block.hash"
          :pencil-action="block.hash" :trash-action="block.hash" @addButtonClicked="addButtonClicked"
          @trashButtonClicked="deleteBlockConfirm" @editButtonClicked="editBlockClicked">
          <draggable class="p-2 cursor-move vx-row mt-3" group="blocks" :animation="700">
            <!--  +
      getFieldWidth(field.entire_line, field.columns_on_form) -->
            <!-- :class="'vx-col ' + fieldColumn(field.columns_on_form, field.entire_line, moduleColumnsOnForm) +' mt-3'"  -->
            <div :class="'vx-col mt-3'"
              :style="fieldColumn(field.columns_on_form, field.entire_line, moduleColumnsOnForm)" group="fields"
              v-for="field in block.fields" :key="field.hash" :id="field.hash" @dragstart="dragStart">
              <!-- :style="'width: ' + getFieldWidth(field.entire_line, field.columns_on_form, moduleColumnsOnForm)" -->
              <vx-card :title="field.title" :pencil-action="field.core ? '' : field.hash"
                @editButtonClicked="editFieldClicked" @trashButtonClicked="deleteFieldConfirm"
                :trash-action="field.core ? '' : field.hash" class="is-field" :id="`field-card-${field.hash}`">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-input style="width: 100% !important;" disabled :placeholder="field.placeholder" />
                    <small class="form-text text-muted mt-3" style="display: block;">{{ field.subtitle }}</small>
                    <span style="float: right">{{ $t("MODULES.FieldType") }}:
                      <b>{{ field.type_name }}</b></span>
                  </div>
                </div>
              </vx-card>
            </div>
          </draggable>
        </vx-card>
      </draggable>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

// Store Module
import draggable from "vuedraggable";
import { FormWizard, TabContent } from "vue-form-wizard";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { PlusCircleIcon } from "vue-feather-icons";
import AddModuleFieldModal from "./AddModuleFieldModal.vue";
import { performFetch } from "../../../helpers.js";

export default {
  components: {
    vSelect,
    draggable,
    FormWizard,
    TabContent,
    PlusCircleIcon,
    flatPickr,
    AddModuleFieldModal
  },
  data() {
    return {
      moduleColumnsOnForm: null,
      invalidLayout: false,
      disableColumnsOnForm: false,
      unavailableSearchTypes: [21, 22, 27, 28, 2, 16, 17, 18, 20, 31, 34],
      availableConcatIdentifierTypes: [this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE],
      fieldsListToKanban: [],
      fieldsListToDocumentName: [],
      integratedKanbans: [],
      optionValue: "",
      statusOption: {},
      editOptionValue: "",
      unsavedLayout: false,
      blockEditDataObject: {
        showOnAdd: true,
        requireIframeSubmitReady: false,
        hash: "",
        title: "",
        collapsed: false,
        visible: false,
        relatedPicklist: [],
        relatedPicklistItem: [],
        roles: []
      },
      blockAddDataObject: {
        showOnAdd: true,
        requireIframeSubmitReady: false,
        contentUrl: '',
        title: "",
        collapsed: false,
        visible: true,
        relatedPicklist: null,
        relatedPicklistItem: null,
        roles: [],
        contentType: {
          "value": "fields",
          "label": "Fields"
        },
        blockContentTypeOptions: [
          {
            "value": "fields",
            "label": "Fields"
          },
          {
            "value": "tabs",
            "label": "Tabs"
          },
          {
            "value": "embbeded",
            "label": "Embbeded content"
          }
        ]
      },
      moduleTabBlocks: [],
      fieldEditData: {
        displayLocation: {},
        allowPastDates: true,
        concatIdentifier: false,
        saveMask: false,
        isDependentField: false,
        picklistFieldOptions: [],
        picklistFieldItemsOptions: {},
        picklistField: {},
        picklistItem: {},
        callApi: false,
        minimalTimeout: 5,
        showFooter: false,
        dependentDisable: true,
        dependentField: {},
        relatedFieldOptions: [],
        options: [],
        relatedTab: false,
        customDisplay: false,
        moduleOptions: [],
        moduleFieldOptions: [],
        showProgressBar: false,
        relatedModule: {},
        relatedField: {},
        relatedKanban: {},
        kanbanTitle: {},
        kanbanDescription: {},
        disableAll: true,
        type: { id: 0, name: "" },
        name: "",
        subtitle: null,
        placeholder: null,
        defaultValue: null,
        showHint: false,
        decimals: 2,
        hint: null,
        length: null,
        mask: null,
        columnsOnForm: 1,
        rowsOnForm: null,
        minValue: null,
        maxValue: null,
        minValueInt: null,
        maxValueInt: null,
        minValueDate: null,
        maxValueDate: null,
        minValueDateTime: null,
        maxValueDateTime: null,
        quickCreate: false,
        massEdit: false,
        showIcon: true,
        mandatory: false,
        entireLine: false,
        unique: false,
        relatedTabName: "",
        relatedTabNameEn: "",
        showRelatedTabName: false,
        secret: false,
        columnsOnFormOptions: [],
        rowsOnFormOptions: [1, 2, 3, 4],
        typeOptions: [],
        isDisabled: false,
        isSearchField: false,
        documentNameField: {}
      },
      hideQuickCreate: [21, 22, 31],
      hideMassEdit: [21, 22, 31],
      hideCallApi: [21, 22, 31],
      hideMandatory: [31],
      hideEntireLine: [],
      hideUnique: [21, 22, 31],
      hideDisabled: [31],
      fieldData: {
        customDisplay: false,
        displayLocation: {},
        matchPattern: '',
        saveMask: false,
        isDependentField: false,
        picklistFieldOptions: [],
        picklistFieldItemsOptions: [],
        picklistField: {},
        picklistItem: {},
        callApi: false,
        minimalTimeout: 3,
        showFooter: false,
        showRelatedTabName: false,
        relatedTabName: "",
        relatedTabNameEn: "",
        dependentDisable: true,
        dependentField: {},
        relatedFieldOptions: [],
        options: ["Adicione um item..."],
        relatedTab: false,
        showProgressBar: false,
        concatIdentifier: false,
        moduleOptions: [],
        relatedItemsModuleOptions: [],
        moduleFieldOptions: [],
        relatedModule: {},
        relatedItemsModule: {},
        relatedField: {},
        relatedKanban: {},
        kanbanTitle: {},
        kanbanDescription: {},
        disableAll: true,
        type: { id: 0, name: "" },
        name: "",
        subtitle: null,
        placeholder: null,
        defaultValue: null,
        showHint: false,
        decimals: 2,
        hint: null,
        length: null,
        columnsOnForm: 1,
        rowsOnForm: null,
        minValue: null,
        maxValue: null,
        minValueInt: null,
        maxValueInt: null,
        minValueDate: null,
        maxValueDate: null,
        minValueDateTime: null,
        maxValueDateTime: null,
        mask: null,
        quickCreate: false,
        massEdit: false,
        showIcon: true,
        mandatory: false,
        entireLine: false,
        unique: false,
        secret: false,
        columnsOnFormOptions: [],
        rowsOnFormOptions: [1, 2, 3, 4],
        typeOptions: [],
        isDisabled: false,
        isSearchField: false,
        documentNameField: {},
        allowPastDates: true
      },
      colorOption: {},
      rolePermissions: {},
      rolePermissionsEdit: {},
      roleList: [],
      roleListSliced: [],
      roleListSlicedEdit: [],
      addFieldForm: {},
      dragItems: {},
      addFieldPopUpActive: false,
      editFieldPopUpActive: false,
      editBlockPopUpActive: false,
      addBlockPopUpActive: false,
      dropElementBlock: "",
      dropElement: "",
      blockData: [],
      blockObject: {},
      moduleInfo: {
        name: "",
        maxColumns: ""
      },
      max_columns: 4,
      currentFieldToDelete: "",
      currentBlockToDelete: "",
      currentBlockToAddField: "",
      currentBlockToEditField: "",
      showPlaceholder: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
      ],
      showLengthField: [1, 19],
      showMinAndMaxValueInt: [2],
      showSecretField: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16, 18, 20],
      showMinAndMaxValueDate: [12],
      showMinAndMaxValueDateTime: [13],
      showMinAndMaxValueTime: [],
      showAddColorsOptionModal: false,
      showEditColorsOptionModal: false,
      colorOptions: [
        {
          color: "danger",
          name: "Vermelho"
        },
        {
          color: "warning",
          name: "Amarelo"
        },
        {
          color: "success",
          name: "Verde"
        }
      ],
      // default parameters
      picklistFields: [],
      picklistFieldItems: {}
      // end default parameters
    };
  },
  watch: {
    "fieldData.type"(type) {
      if (type.id === 29) {
        this.fieldData.options = [
          { color: "primary", value: this.$t("MODULES.addItem") }
        ];
      } else {
        this.fieldData.options = [this.$t("MODULES.addItem")];
      }
    },
    showAddColorsOptionModal(value) {
      if (!value) {
        if (JSON.stringify(this.colorOption) === "{}") {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: "O item precisa ter uma cor anexada!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          this.showAddColorsOptionModal = true;
        } else {
          this.addOptionAddForm(29, true);
        }
      }
    },
    showEditColorsOptionModal(value) {
      if (!value) {
        if (JSON.stringify(this.colorOption) === "{}") {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: "O item precisa ter uma cor anexada!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          this.showEditColorsOptionModal = true;
        } else {
          this.addOptionEditForm(29, true);
        }
      }
    },
    // 'fieldData.defaultValue' (value) {
    //   console.log(value)
    // },
    "fieldEditData.relatedTab"(value) {
      if (value) {
        this.fieldEditData.showRelatedTabName = true;
      } else {
        this.fieldEditData.showRelatedTabName = false;
      }
    },
    "fieldData.relatedTab"(value) {
      if (value) {
        this.fieldData.showRelatedTabName = true;
      } else {
        this.fieldData.showRelatedTabName = false;
      }
    },
    addFieldPopUpActive(value) {
      if (!value) {
        this.resetNewFieldForm();
      }
    },
    editFieldPopUpActive(value) {
      if (!value) {
        this.resetEditFieldForm();
      }
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    }
  },
  computed: {
    onChangeEditBlockPopUp: {
      get() {
        return this.editBlockPopUpActive;
      },
      set(val) {
        if (val === false) {
          this.blockObject[this.blockEditDataObject["hash"]]["title"] = this.blockEditDataObject["title"];
          this.blockObject[this.blockEditDataObject["hash"]]["collapsed"] = this.blockEditDataObject["collapsed"];
          this.blockObject[this.blockEditDataObject["hash"]]["visible"] = this.blockEditDataObject["visible"];
          this.blockObject[this.blockEditDataObject["hash"]]["relatedPicklist"] = this.blockEditDataObject["relatedPicklist"];
          this.blockObject[this.blockEditDataObject["hash"]]["relatedPicklistItem"] = this.blockEditDataObject["relatedPicklistItem"];
          this.blockObject[this.blockEditDataObject["hash"]]["showOnAdd"] = this.blockEditDataObject["showOnAdd"];
          this.blockObject[this.blockEditDataObject["hash"]]["requireIframeSubmitReady"] = this.blockEditDataObject["requireIframeSubmitReady"];
          this.blockObject[this.blockEditDataObject["hash"]]["roles"] = Array.isArray(this.blockEditDataObject["roles"]) ? this.blockEditDataObject["roles"] : [];

          this.unsavedLayout = true;
        }
        this.editBlockPopUpActive = val;
      }
    },
    modulesData() {
      return this.$store.state.customModules.modules;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    serializeBlockPicklistFieldItems(picklistData) {
      console.log('serializing');
      console.log(picklistData);

      if (!picklistData || picklistData.length === 0) {
        return [];
      }

      const selectedItems = picklistData.map(item => item.hash);

      // selectedItems = array de hashes selecionados
      // this.picklistFieldItems = { hash: [array de items], ... }
      const accumulated = Object.entries(this.picklistFieldItems).reduce((acc, [key, value]) => {
        if (selectedItems.includes(key)) {
          const listLabel = this.picklistFields.find(x => x.hash === key).name;
          const options = value.map(item => {
            return {
              hash: item.hash,
              name: `${listLabel} - ${item.name}`
            };
          });
          console.log(options);
          acc = acc.concat(options);
          // acc = []
        }
        return acc;
      }, []);
      console.log(accumulated);
      return accumulated;

      return [];

      // picklistFieldItems[blockEditDataObject.relatedPicklist.hash]
    },
    async resetAddModuleFieldProps() {
      this.addFieldPopUpActive = false;
      this.currentBlockToAddField = '';

      this.$vs.loading.close();

      await this.loadData();

      this.$vs.notify({
        title: this.$t("MODULES.operationCompletedTitle"),
        text: this.$t("MODULES.fieldAddedSuccess"),
        iconPack: "feather",
        icon: "icon-check",
        color: "success"
      });
    },
    onPicklistFieldChange(origin) {

      if (origin === 'add') {
        this.blockAddDataObject.relatedPicklistItem = []
      } else {
        this.blockEditDataObject.relatedPicklistItem = []
      }

      // Object.keys(this.keyPicklistItems[fieldHash]).forEach(picklistItemHash => {
      //   this.keyPicklistItems[fieldHash][picklistItemHash] = false
      // })

      // if(event !== null) {
      //   if(event.value !== 0) {
      //     this.keyPicklistItems[fieldHash][event.value] = true
      //   }
      // }

      // this.setBlocks(true)

    },
    async checkIfModuleHasQuickCreateFields(moduleHash) {
      // let hasQuickCreateFields = false

      return new Promise(async (resolve, reject) => {
        let hasQuickCreateFields = false;

        await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_check_if_module_has_quick_create_fields",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_hash: moduleHash
          }
        })
          .then(async response => {
            this.$vs.loading.close();
            if (response.status === 200) {
              await response.json().then(_response => {
                hasQuickCreateFields = _response["has_quick_create_fields"];

                resolve(hasQuickCreateFields);
              });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else {
              hasQuickCreateFields = false;
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("MODULES.hashInvalidTitle"),
                text: this.$t("MODULES.errorSearchModulos"),
                iconPack: "feather",
                icon: "icon-check",
                color: "warning"
              });
              resolve(hasQuickCreateFields);
            }
          })
          .catch(e => {
            console.log(e);
            hasQuickCreateFields = false;
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
            throw new Error(e.message);
            resolve(hasQuickCreateFields);
          });

        resolve(hasQuickCreateFields);
      });

      // return hasQuickCreateFields
    },
    getFieldWidth(fieldEntireLine, fieldColumn, moduleColumns) {

      const fraction = fieldColumn / moduleColumns;
      const percentageClass = fraction === 1 ? 'w-full' : `w-${Math.round(fraction * 12)}/12`;

      let fieldWidth = "";

      if (fieldEntireLine) {
        switch (fieldColumn) {
          case 1:
            fieldWidth = "24%!important;";

            break;

          case 2:
            fieldWidth = "49.5%!important;";

            break;

          case 3:
            fieldWidth = "74.5%!important;";

            break;

          case 4:
            fieldWidth = "100%!important;";

            break;

          default:
            break;
        }
      }

      return fieldWidth;
    },
    dependentListChangeEdit() {
      // console.log(this.fieldEditData.picklistField);
    },
    discardStatusFieldChanges() {
      this.addFieldPopUpActive = true;
    },
    addOptionEditForm(fieldTypeId = null, submit = false) {
      if (fieldTypeId === 29 && !submit) {
        this.showEditColorsOptionModal = true;

        if (this.editOptionValue === "") {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.emptyItem"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });
        }
      } else if (fieldTypeId === 29 && submit) {
        this.fieldEditData.options.push({
          color: this.colorOption.color,
          value: this.editOptionValue
        });
        this.colorOption = {};
        this.editOptionValue = "";
        this.showEditColorsOptionModal = false;
      } else if (this.editOptionValue !== "") {
        this.fieldEditData.options.push(this.editOptionValue);
        this.editOptionValue = "";
      } else {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      }
    },
    addOptionAddForm(fieldTypeId = null, submit = false) {
      if (fieldTypeId === 29 && !submit) {
        this.showAddColorsOptionModal = true;

        if (this.optionValue === "") {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.emptyItem"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });
        }
      } else if (fieldTypeId === 29 && submit) {
        if (this.fieldData.options[0].value === "Adicione um item...") {
          this.fieldData.options = [];
        }
        this.fieldData.options.push({
          color: this.colorOption.color,
          value: this.optionValue
        });
        this.optionValue = "";
        this.colorOption = {};
        this.showAddColorsOptionModal = false;
      } else if (this.optionValue !== "") {
        if (this.fieldData.options[0] === "Adicione um item...") {
          this.fieldData.options = [];
        }
        this.fieldData.options.push(this.optionValue);
        this.optionValue = "";
      } else {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.emptyItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      }
    },
    removeItemEditForm(index) {
      this.fieldEditData.options.splice(index, 1);

      if (this.fieldEditData.options.length === 0) {
        this.fieldEditData.defaultValue = null;
      }
    },
    removeItemAddForm(index) {
      if (
        index === 0 &&
        this.fieldData.options[0].hasOwnProperty("value") &&
        this.fieldData.options[0]["value"] === "Adicione um item..."
      ) {
      } else if (
        index === 0 &&
        this.fieldData.options[0] === "Adicione um item..."
      ) {
      } else {
        this.fieldData.options.splice(index, 1);
      }
    },
    async onRelatedModuleEditChange(val) {
      this.$vs.loading({ type: "default" });

      this.getRelatedFields(this.$route.params.moduleHash, val.hash, "edit");

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_get_application_module_fields",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: val.hash
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(responseData => {
              const moduleFieldList = [];

              responseData.module.payload.forEach(item => {

                if (item.content_type === 'tabs') {
                  this.moduleTabBlocks.push({
                    value: item.hash,
                    label: item.title
                  })
                }

                item.fields.forEach(fieldItem => {
                  const fieldObject = {
                    hash: fieldItem.hash,
                    name: `${item.title} - ${fieldItem.title}`
                  };

                  if (
                    fieldItem.type_id !== 24 &&
                    fieldItem.type_id !== 25 &&
                    fieldItem.type_id !== 32 &&
                    fieldItem.type_id !== 33
                  ) {
                    moduleFieldList.push(fieldObject);
                  }
                });
              });

              moduleFieldList.sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              });

              this.fieldEditData.moduleFieldOptions = moduleFieldList;

              this.$vs.loading.close();
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.errorSearchModulos"),
            iconPack: "feather",
            icon: "icon-check",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async getRelatedFields(moduleToken, relatedModuleToken, action = "add") {
      await performFetch(this.$store.state.auth.api_url, {
        command: "get_module_related_fields",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: moduleToken,
          related_module_token: relatedModuleToken
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(responseData => {
              const relatedFields = [];

              responseData.payload.forEach(item => {
                const fieldObject = {
                  hash: item.hash,
                  name: item.name
                };

                relatedFields.push(fieldObject);
              });

              relatedFields.sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              });

              if (action === "add") {
                this.fieldData.relatedFieldOptions = relatedFields;

                if (
                  Array.isArray(this.fieldData.relatedFieldOptions) &&
                  this.fieldData.relatedFieldOptions.length > 0
                ) {
                  this.fieldData.dependentDisable = false;
                } else {
                  this.fieldData.dependentDisable = true;
                }

                this.fieldData.dependentField = {};
              } else {
                this.fieldEditData.relatedFieldOptions = relatedFields;

                // console.log(this.fieldEditData.relatedFieldOptions)

                if (Array.isArray(this.fieldEditData.relatedFieldOptions) && this.fieldEditData.relatedFieldOptions.length > 0) {
                  this.fieldEditData.dependentDisable = false;
                } else {
                  this.fieldEditData.dependentDisable = true;
                }
              }

              this.$vs.loading.close();
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.errorSearchModulos"),
            iconPack: "feather",
            icon: "icon-check",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async onRelatedModuleChange(val) {
      this.getRelatedFields(this.$route.params.moduleHash, val.hash, "add");

      this.$vs.loading({ type: "default" });

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_get_application_module_fields",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: val.hash
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(responseData => {
              const moduleFieldList = [];

              responseData.module.payload.forEach(item => {
                item.fields.forEach(fieldItem => {
                  const fieldObject = {
                    hash: fieldItem.hash,
                    name: `${item.title} - ${fieldItem.title}`
                  };

                  if (
                    fieldItem.type_id !== 24 &&
                    fieldItem.type_id !== 25 &&
                    fieldItem.type_id !== 32 &&
                    fieldItem.type_id !== 33
                  ) {
                    moduleFieldList.push(fieldObject);
                  }
                });
              });

              moduleFieldList.sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              });

              this.fieldData.moduleFieldOptions = moduleFieldList;

              this.$vs.loading.close();
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.errorSearchModulos"),
            iconPack: "feather",
            icon: "icon-check",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async onFieldEditTypeChange(val) {
      if (val.id === 31) {
        this.disableColumnsOnForm = true;
      } else {
        this.disableColumnsOnForm = false;
      }

      if (val.id === 25 || val.id === 30 || val.id === 33) {
        await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_get_application_modules",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
          .then(async response => {
            this.$vs.loading.close();
            if (response.status === 200) {
              response.json().then(responseData => {
                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    };

                    this.fieldEditData.moduleOptions.push(moduleObject);
                  }
                });
              });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("MODULES.FailedOperation"),
                text: this.$t("MODULES.errorSearchModulos"),
                iconPack: "feather",
                icon: "icon-check",
                color: "danger"
              });
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
            throw new Error(e.message);
          });
      } else if (val.id === 31) {
        await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_get_module_related_modules",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_hash: this.$route.params.moduleHash
          }
        })
          .then(async response => {
            this.$vs.loading.close();
            if (response.status === 200) {
              this.fieldEditData.relatedItemsModuleOptions = [];

              response.json().then(responseData => {
                // this.fieldData.moduleOptions = responseData.modules

                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    };

                    this.fieldEditData.relatedItemsModuleOptions.push(
                      moduleObject
                    );
                  }
                });
              });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("MODULES.FailedOperation"),
                text: this.$t("MODULES.errorSearchModulos"),
                iconPack: "feather",
                icon: "icon-check",
                color: "danger"
              });
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
            throw new Error(e.message);
          });
      }
    },
    async onFieldTypeChange(val) {
      val.id > 0
        ? (this.fieldData.disableAll = false)
        : (this.fieldData.disableAll = true);

      if (val.id === 31) {
        this.fieldData.columnsOnForm = 4;
        this.disableColumnsOnForm = true;
      } else {
        this.fieldData.columnsOnForm = 1;
        this.disableColumnsOnForm = false;
      }

      if (val.id === 25 || val.id === 30 || val.id === 33) {
        await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_get_application_modules",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
          .then(async response => {
            this.$vs.loading.close();
            if (response.status === 200) {
              this.fieldData.moduleOptions = [];

              response.json().then(responseData => {
                // this.fieldData.moduleOptions = responseData.modules

                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    };

                    this.fieldData.moduleOptions.push(moduleObject);
                  }
                });
              });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("MODULES.FailedOperation"),
                text: this.$t("MODULES.errorSearchModulos"),
                iconPack: "feather",
                icon: "icon-check",
                color: "danger"
              });
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
            throw new Error(e.message);
          });
      } else if (val.id === 31) {
        await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_get_module_related_modules",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_hash: this.$route.params.moduleHash
          }
        })
          .then(async response => {
            this.$vs.loading.close();
            if (response.status === 200) {
              this.fieldData.relatedItemsModuleOptions = [];

              response.json().then(responseData => {
                // this.fieldData.moduleOptions = responseData.modules

                // console.log(responseData);

                responseData.modules.forEach(item => {
                  if (item.hash !== this.$route.params.moduleHash) {
                    const moduleObject = {
                      hash: item.hash,
                      name: item.name,
                      type: item.type.id
                    };

                    this.fieldData.relatedItemsModuleOptions.push(moduleObject);
                  }
                });
              });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("MODULES.FailedOperation"),
                text: this.$t("MODULES.errorSearchModulos"),
                iconPack: "feather",
                icon: "icon-check",
                color: "danger"
              });
            }
          })
          .catch(e => {
            console.log(e);
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.errorSearchModulos"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
            throw new Error(e.message);
          });
      }
    },
    validateStep1Add() {
      if (this.fieldData.type.id === 0) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.typeRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.fieldData.type.id === 31 && this.fieldData.rowsOnForm === null) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.formLinesRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (!this.fieldData.name) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.nameRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.fieldData.showHint && !this.fieldData.hint) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.showTipSelected"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 30 &&
        this.fieldData.moduleOptions.filter(
          x => x.type === 6 && this.integratedKanbans.indexOf(x.hash) === -1
        ).length === 0
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.noKanbansAvailable"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      return true;
    },
    validateStep1Edit() {
      if (this.fieldEditData.type.id === 0) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.typeRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.fieldEditData.type.id === 31) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.formLinesRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (!this.fieldEditData.name) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.nameRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.fieldEditData.showHint && !this.fieldEditData.hint) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.showTipSelected"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      return true;
    },
    async validateStep2Add() {
      if (this.fieldData.type.id === 31) {
        if (
          this.fieldData.relatedItemsModule === null ||
          JSON.stringify(this.fieldData.relatedItemsModule) === "{}"
        ) {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.relatedModuleRequired"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          return false;
        }

        const hasQuickCreateFields = await this.checkIfModuleHasQuickCreateFields(
          this.fieldData.relatedItemsModule.hash
        );

        if (!hasQuickCreateFields) {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.noQuickCreateFields"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          return false;
        }
      }

      // if(this.fieldData.type.id === 28) {
      //   if(!this.fieldData.documentNameField || JSON.stringify(this.fieldData.documentNameField) === '{}') {
      //     this.$vs.notify({
      //       title: this.$t('MODULES.hashInvalidTitle'),
      //       text: 'O campo!',
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'warning'
      //     })

      //     return false
      //   }
      // }

      if (this.fieldData.type.id === 2) {
        if (this.fieldData.defaultValue && this.fieldData.defaultValue !== "") {
          let value = null;

          value = parseInt(this.fieldData.defaultValue);

          if (isNaN(value)) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.defaultNumeric"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          if (
            this.fieldData.minValueInt &&
            value !== null &&
            value < this.fieldData.minValueInt
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxCriteria"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          if (
            this.fieldData.maxValueInt &&
            value !== null &&
            value > this.fieldData.maxValueInt
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxCriteria"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }
        }
      }

      if (
        this.fieldData.picklistFieldOptions.length > 0 &&
        this.fieldData.picklistField !== null &&
        JSON.stringify(this.fieldData.picklistField) !== "{}" &&
        (this.fieldData.picklistItem === null ||
          JSON.stringify(this.fieldData.picklistItem) === "{}")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.selectListItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 24 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0] === "Adicione um item..."))
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 32 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0] === "Adicione um item..."))
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 29 &&
        (this.fieldData.defaultValue === null ||
          JSON.stringify(this.fieldData.defaultValue) === "{}")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.statusDefaultValue"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 29 &&
        (this.fieldData.options.length === 0 ||
          (this.fieldData.options.length === 1 &&
            this.fieldData.options[0]["value"] === "Adicione um item..."))
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.relatedKanban) === "{}"
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.chooseKanbanModule"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.kanbanTitle) === "{}"
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.chooseTitleField"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 30 &&
        JSON.stringify(this.fieldData.kanbanDescription) === "{}"
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.chooseDescriptionField"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.showLengthField.includes(this.fieldData.type.id) &&
        (parseInt(this.fieldData.length) > 3000 ||
          parseInt(this.fieldData.length) < 0) &&
        (this.fieldData.length !== "" ||
          this.fieldData.length !== null ||
          this.fieldData.length === "e")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.sizeRange"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 25 &&
        !(
          Object.keys(this.fieldData.relatedModule).length === 0 &&
          this.fieldData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldData.relatedField).length === 0 &&
        this.fieldData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedFieldRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 33 &&
        !(
          Object.keys(this.fieldData.relatedModule).length === 0 &&
          this.fieldData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldData.relatedField).length === 0 &&
        this.fieldData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedFieldRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 25 &&
        Object.keys(this.fieldData.relatedModule).length === 0 &&
        this.fieldData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedModuleRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldData.type.id === 33 &&
        Object.keys(this.fieldData.relatedModule).length === 0 &&
        this.fieldData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedModuleRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.showMinAndMaxValueInt.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueInt && this.fieldData.maxValueInt) {
          if (
            parseInt(this.fieldData.minValueInt) >
            parseInt(this.fieldData.maxValueInt)
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxValueError"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          this.fieldData.minValue = this.fieldData.minValueInt;
          this.fieldData.maxValue = this.fieldData.maxValueInt;
        }
      } else if (this.showMinAndMaxValueDate.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueDate && this.fieldData.maxValueDate) {
          let minValueDateStr = "";
          let maxValueDateStr = "";

          try {
            minValueDateStr = `${this.fieldData.minValueDate.split("/")[2]}-${this.fieldData.minValueDate.split("/")[1]
              }-${this.fieldData.minValueDate.split("/")[0]}`;
          } catch (e) {
            console.error(e);
          }

          try {
            maxValueDateStr = `${this.fieldData.maxValueDate.split("/")[2]}-${this.fieldData.maxValueDate.split("/")[1]
              }-${this.fieldData.maxValueDate.split("/")[0]}`;
          } catch (e) {
            console.error(e);
          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(minValueDateStr);
            const maxValueDateObject = new Date(maxValueDateStr);

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t("MODULES.hashInvalidTitle"),
                text: this.$t("MODULES.minMaxValueError"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });

              return false;
            }
          }

          this.fieldData.minValue = minValueDateStr;
          this.fieldData.maxValue = maxValueDateStr;
        }
      } else if (
        this.showMinAndMaxValueDateTime.includes(this.fieldData.type.id)
      ) {
        if (
          this.fieldData.minValueDateTime &&
          this.fieldData.maxValueDateTime
        ) {
          let minValueDateStr = "";
          let maxValueDateStr = "";

          const minTime = this.fieldData.minValueDateTime.split(" ")[1].trim();
          const minDate = this.fieldData.minValueDateTime.split(" ")[0].trim();
          const maxTime = this.fieldData.maxValueDateTime.split(" ")[1].trim();
          const maxDate = this.fieldData.maxValueDateTime.split(" ")[0].trim();

          try {
            minValueDateStr = `${minDate.split("/")[2]}-${minDate.split("/")[1]
              }-${minDate.split("/")[0]}`;
          } catch (e) { }

          try {
            maxValueDateStr = `${maxDate.split("/")[2]}-${maxDate.split("/")[1]
              }-${maxDate.split("/")[0]}`;
          } catch (e) { }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(
              `${minValueDateStr} ${minTime}`
            );
            const maxValueDateObject = new Date(
              `${maxValueDateStr} ${maxTime}`
            );

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t("MODULES.hashInvalidTitle"),
                text: this.$t("MODULES.minMaxValueError"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });

              return false;
            }
          }

          this.fieldData.minValue = `${minValueDateStr} ${minTime}`;
          this.fieldData.maxValue = `${maxValueDateStr} ${maxTime}`;
        }
      }

      return true;
    },
    async validateStep2Edit() {

      if (this.fieldData.type.id === 31) {
        if (
          this.fieldData.relatedItemsModule === null ||
          JSON.stringify(this.fieldData.relatedItemsModule) === "{}"
        ) {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.relatedModuleRequired"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          return false;
        }

        const hasQuickCreateFields = await this.checkIfModuleHasQuickCreateFields(
          this.fieldData.relatedItemsModule.hash
        );

        if (!hasQuickCreateFields) {
          this.$vs.notify({
            title: this.$t("MODULES.hashInvalidTitle"),
            text: this.$t("MODULES.noQuickCreateFields"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });

          return false;
        }
      }

      if (this.fieldEditData.type.id === 2) {
        if (
          this.fieldEditData.defaultValue &&
          this.fieldEditData.defaultValue !== ""
        ) {
          let value = null;

          value = parseInt(this.fieldEditData.defaultValue);

          if (isNaN(value)) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.defaultNumeric"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          if (
            this.fieldEditData.minValueInt &&
            value !== null &&
            value < this.fieldEditData.minValueInt
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxCriteria"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          if (
            this.fieldEditData.maxValueInt &&
            value !== null &&
            value > this.fieldEditData.maxValueInt
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxCriteria"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }
        }
      }

      if (
        this.fieldEditData.picklistFieldOptions.length > 0 &&
        this.fieldEditData.picklistField !== null &&
        JSON.stringify(this.fieldEditData.picklistField) !== "{}" &&
        (this.fieldEditData.picklistItem === null ||
          JSON.stringify(this.fieldEditData.picklistItem) === "{}")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.selectListItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 24 &&
        this.fieldEditData.options.length === 0
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 32 &&
        this.fieldEditData.options.length === 0
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.minOneItem"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 29 &&
        (this.fieldEditData.defaultValue === null ||
          JSON.stringify(this.fieldEditData.defaultValue) === "{}")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.statusDefaultValue"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.showLengthField.includes(this.fieldEditData.type.id) &&
        (parseInt(this.fieldEditData.length) > 3000 ||
          parseInt(this.fieldEditData.length) < 0) &&
        (this.fieldEditData.length !== "" ||
          this.fieldEditData.length !== null ||
          this.fieldEditData.length === "e")
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.sizeRange"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 25 &&
        Object.keys(this.fieldEditData.relatedModule).length === 0 &&
        this.fieldEditData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: "O Campo Módulo Relacionado precisa ser preenchido",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 33 &&
        Object.keys(this.fieldEditData.relatedModule).length === 0 &&
        this.fieldEditData.relatedModule.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: "O Campo Módulo Relacionado precisa ser preenchido",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 25 &&
        !(
          Object.keys(this.fieldEditData.relatedModule).length === 0 &&
          this.fieldEditData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldEditData.relatedField).length === 0 &&
        this.fieldEditData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedFieldRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 33 &&
        !(
          Object.keys(this.fieldEditData.relatedModule).length === 0 &&
          this.fieldEditData.relatedModule.constructor === Object
        ) &&
        Object.keys(this.fieldEditData.relatedField).length === 0 &&
        this.fieldEditData.relatedField.constructor === Object
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.relatedFieldRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 25 &&
        this.fieldEditData.relatedTab &&
        this.fieldEditData.relatedTabName === ""
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.tabNameRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.fieldEditData.type.id === 25 && this.fieldEditData.customDisplay && Object.keys(this.fieldEditData.displayLocation).length === 0) {
        this.$vs.notify({
          title: this.$t("MODULES.displayLocationRequiredTitle"),
          text: this.$t("MODULES.displayLocationRequiredMessage"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 33 &&
        this.fieldEditData.relatedTab &&
        this.fieldEditData.relatedTabName === ""
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.tabNameRequired"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (
        this.fieldEditData.type.id === 29 &&
        this.fieldEditData.options.length === 0
      ) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.statusFieldNeedsAtLeastOneOption"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      if (this.showMinAndMaxValueInt.includes(this.fieldEditData.type.id)) {
        if (this.fieldEditData.minValueInt && this.fieldEditData.maxValueInt) {
          if (
            parseInt(this.fieldEditData.minValueInt) >
            parseInt(this.fieldEditData.maxValueInt)
          ) {
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.minMaxValueError"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });

            return false;
          }

          this.fieldEditData.minValue = this.fieldEditData.minValueInt;
          this.fieldEditData.maxValue = this.fieldEditData.maxValueInt;
        }
      } else if (
        this.showMinAndMaxValueDate.includes(this.fieldEditData.type.id)
      ) {
        if (
          this.fieldEditData.minValueDate &&
          this.fieldEditData.maxValueDate
        ) {
          let minValueDateStr = "";
          let maxValueDateStr = "";

          try {
            minValueDateStr = `${this.fieldEditData.minValueDate.split("/")[2]
              }-${this.fieldEditData.minValueDate.split("/")[1]}-${this.fieldEditData.minValueDate.split("/")[0]
              }`;
          } catch (e) { }

          try {
            maxValueDateStr = `${this.fieldEditData.maxValueDate.split("/")[2]
              }-${this.fieldEditData.maxValueDate.split("/")[1]}-${this.fieldEditData.maxValueDate.split("/")[0]
              }`;
          } catch (e) { }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(minValueDateStr);
            const maxValueDateObject = new Date(maxValueDateStr);

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t("MODULES.hashInvalidTitle"),
                text: this.$t("MODULES.minMaxValueError"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });

              return false;
            }
          }

          this.fieldEditData.minValue = minValueDateStr;
          this.fieldEditData.maxValue = maxValueDateStr;
        }
      } else if (
        this.showMinAndMaxValueDateTime.includes(this.fieldEditData.type.id)
      ) {
        if (
          this.fieldEditData.minValueDateTime &&
          this.fieldEditData.maxValueDateTime
        ) {
          let minValueDateStr = "";
          let maxValueDateStr = "";

          const minTime = this.fieldEditData.minValueDateTime
            .split(" ")[1]
            .trim();
          const minDate = this.fieldEditData.minValueDateTime
            .split(" ")[0]
            .trim();
          const maxTime = this.fieldEditData.maxValueDateTime
            .split(" ")[1]
            .trim();
          const maxDate = this.fieldEditData.maxValueDateTime
            .split(" ")[0]
            .trim();

          try {
            minValueDateStr = `${minDate.split("/")[2]}-${minDate.split("/")[1]
              }-${minDate.split("/")[0]}`;
          } catch (e) { }

          try {
            maxValueDateStr = `${maxDate.split("/")[2]}-${maxDate.split("/")[1]
              }-${maxDate.split("/")[0]}`;
          } catch (e) { }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(
              `${minValueDateStr} ${minTime}`
            );
            const maxValueDateObject = new Date(
              `${maxValueDateStr} ${maxTime}`
            );

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: this.$t("MODULES.hashInvalidTitle"),
                text: this.$t("MODULES.minMaxValueError"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });

              return false;
            }
          }

          this.fieldEditData.minValue = `${minValueDateStr} ${minTime}`;
          this.fieldEditData.maxValue = `${maxValueDateStr} ${maxTime}`;
        }
      }

      return true;
    },
    async addBlock() {

      let relatedPicklistHash = null;
      let relatedPicklistItemHash = null;

      if (this.blockAddDataObject.relatedPicklist !== null && typeof this.blockAddDataObject.relatedPicklist === 'object' && 'hash' in this.blockAddDataObject.relatedPicklist) {
        relatedPicklistHash = this.blockAddDataObject.relatedPicklist.hash
      }

      if (this.blockAddDataObject.relatedPicklistItem !== null && typeof this.blockAddDataObject.relatedPicklistItem === 'object' && 'hash' in this.blockAddDataObject.relatedPicklistItem) {
        relatedPicklistItemHash = this.blockAddDataObject.relatedPicklistItem.hash
      }

      if (relatedPicklistHash !== null && relatedPicklistItemHash === null) {

        this.$vs.notify({
          title: this.$t("MODULES.AttentionMessagePicklistMessageOnBlockPopup"),
          text: this.$t("MODULES.InvalidPicklistMessageOnBlockPopup"),
          iconPack: "feather",
          icon: "icon-check",
          color: "warning"
        });

        return;
      }


      this.$vs.loading({ type: "default" });
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: "module_management_add_application_module_block",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          block: {
            name: this.blockAddDataObject.title,
            collapsed: this.blockAddDataObject.collapsed,
            visible: this.blockAddDataObject.visible,
            relatedPicklist: relatedPicklistHash,
            relatedPicklistItem: relatedPicklistItemHash,
            contentType: this.blockAddDataObject.contentType && this.blockAddDataObject.contentType.value,
            contentUrl: this.blockAddDataObject.contentUrl,
            show_on_add: this.blockAddDataObject.showOnAdd,
            requireIframeSubmitReady: this.blockAddDataObject.requireIframeSubmitReady,
            roles: Array.isArray(this.blockAddDataObject.roles) ? this.blockAddDataObject.roles : []
          }
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.addBlockPopUpActive = false;

            this.$vs.loading.close();

            this.blockAddDataObject.title = "";
            this.blockAddDataObject.collapsed = false;
            this.blockAddDataObject.visible = true;
            this.blockAddDataObject.relatedPicklist = null;
            this.blockAddDataObject.relatedPicklistItem = null;
            this.blockAddDataObject.showOnAdd = true;
            this.blockAddDataObject.requireIframeSubmitReady = false;
            this.blockAddDataObject.roles = [];

            await this.loadData();

            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: this.$t("MODULES.blockAddedSuccessfully"),
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.blockAdditionError"),
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.blockAdditionError"),
            iconPack: "feather",
            icon: "icon-check",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    addBlockCall() {
      this.addBlockPopUpActive = true;

      document.querySelectorAll("div.vs-popup").forEach(item => {
        if (
          item.children[1].children[0].id === "add-block" ||
          item.children[1].children[0].id === "edit-block"
        ) {
          // item.style.width = '500px'
          item.children[1].style.width = "500px";
          item.setAttribute("style", "width: 500px!important");
        }
      });
    },
    sliderChange(elementId, e) {
      if (e === 0) {
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.add("vs-slider-dark");
      } else if (e === 1) {
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.add("vs-slider-primary");
      } else {
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-${elementId}`)
          .classList.add("vs-slider-success");
      }
    },
    sliderEditChange(elementId, e) {
      if (e === 0) {
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.add("vs-slider-dark");
      } else if (e === 1) {
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.add("vs-slider-primary");
      } else {
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-dark");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-primary");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.remove("vs-slider-success");
        document
          .querySelector(`#slider-edit-${elementId}`)
          .classList.add("vs-slider-success");
      }
    },
    async updateLayout() {

      const blockLayoutList = [];

      let hasInvalidPicklistBlock = false;
      let invalidBlockName = '';

      document.querySelectorAll(".is-block").forEach((item, key) => {
        const blockHash = item.id.split("block-")[1];

        const blockIndex = key + 1;

        const blockObject = {};

        blockObject["block_hash"] = blockHash;
        blockObject["block_index"] = blockIndex;
        blockObject["block_collapsed"] = this.blockObject[blockHash].collapsed;
        blockObject["block_visible"] = this.blockObject[blockHash].visible;
        blockObject["block_title"] = this.blockObject[blockHash].title;
        blockObject["show_on_add"] = this.blockObject[blockHash].showOnAdd;
        blockObject["require_iframe_submit_ready"] = this.blockObject[blockHash].requireIframeSubmitReady;
        blockObject["block_roles"] = Array.isArray(this.blockObject[blockHash].roles) ? this.blockObject[blockHash].roles : [];

        let relatedPicklistHash = null;
        let relatedPicklistItemHash = null;

        if (this.blockObject[blockHash].relatedPicklist !== null && Array.isArray(this.blockObject[blockHash].relatedPicklist)) {
          // console.log('here');
          relatedPicklistHash = this.blockObject[blockHash].relatedPicklist.map(item => item.hash);
          // relatedPicklistHash = this.blockObject[blockHash].relatedPicklist.hash
        }

        if (this.blockObject[blockHash].relatedPicklistItem !== null && Array.isArray(this.blockObject[blockHash].relatedPicklistItem)) {
          // console.log('here2');
          relatedPicklistItemHash = this.blockObject[blockHash].relatedPicklistItem.map(item => item.hash);
        }

        if (relatedPicklistHash !== null && relatedPicklistItemHash === null) {

          hasInvalidPicklistBlock = true;
          invalidBlockName = this.blockObject[blockHash].title;
        }

        blockObject["block_related_picklist"] = relatedPicklistHash;
        blockObject["block_related_picklist_item"] = relatedPicklistItemHash;

        blockObject["fields"] = [];

        item
          .querySelector(".vx-card")
          .querySelector(
            ".vx-card__collapsible-content.vs-con-loading__container"
          )
          .querySelector(".vx-card__body")
          .children[0].children.forEach((fieldItem, fieldKey) => {
            const fieldHash = fieldItem.id;

            const fieldIndex = fieldKey + 1;

            blockObject["fields"].push({
              field_hash: fieldHash,
              field_index: fieldIndex
            });
          });

        blockLayoutList.push(blockObject);
      });

      if (hasInvalidPicklistBlock) {
        this.$vs.notify({
          title: this.$t("MODULES.AttentionMessagePicklistMessageOnBlockPopup"),
          text: this.$t("MODULES.InvalidPicklistMessageOnBlockPopup") + ' - Bloco: ' + invalidBlockName,
          iconPack: "feather",
          icon: "icon-check",
          color: "warning"
        });

        return;
      }

      this.$vs.loading({ type: "default" });

      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: "module_management_update_module_fields_layout",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          blocks: blockLayoutList
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.unsavedLayout = false;

            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: "Layout atualizado com sucesso!",
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: this.$t("MODULES.layoutUpdateError"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });

            this.unsavedLayout = true;
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.operationCompletedTitle"),
            text: this.$t("MODULES.layoutUpdateError"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    editBlockClicked(elementHash) {
      this.editBlockPopUpActive = true;

      const currentBlock = this.blockObject[elementHash];

      this.blockEditDataObject.hash = currentBlock.hash;
      this.blockEditDataObject.title = currentBlock.title;
      this.blockEditDataObject.collapsed = currentBlock.collapsed;
      this.blockEditDataObject.visible = currentBlock.visible;
      this.blockEditDataObject.relatedPicklist = currentBlock.relatedPicklist === null ? [] : currentBlock.relatedPicklist;
      this.blockEditDataObject.relatedPicklistItem = currentBlock.relatedPicklistItem === null ? [] : currentBlock.relatedPicklistItem;
      this.blockEditDataObject.showOnAdd = currentBlock.showOnAdd === null ? [] : currentBlock.showOnAdd;
      this.blockEditDataObject.requireIframeSubmitReady = currentBlock.requireIframeSubmitReady === true;
      this.blockEditDataObject.roles = Array.isArray(currentBlock.roles) ? [...currentBlock.roles] : [];
    },
    async editFieldClicked(elementHash) {

      const closestBlockId = document.querySelector(`#field-card-${elementHash}`).closest('.is-block').id.replace('block-', '')

      this.currentBlockToEditField = closestBlockId

      document
        .querySelectorAll(".wizard-nav.wizard-nav-pills")[0]
        .querySelectorAll("li")[0]
        .click();

      this.$vs.loading({ type: "default" });

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_get_application_module_field_detail",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          field_token: elementHash
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(async responseData => {
              const fieldData = responseData.field;

              const typeObject = this.fieldData.typeOptions.find(
                o => o.id === responseData.field.type_id
              );

              this.fieldEditData.options = [];

              this.fieldEditData.hash = fieldData.hash;
              this.fieldEditData.type = typeObject;

              this.fieldEditData.name = fieldData.title;
              this.fieldEditData.subtitle = fieldData.subtitle;
              this.fieldEditData.placeholder = fieldData.place_holder;
              this.fieldEditData.defaultValue = fieldData.defaultValue;
              this.fieldEditData.showHint = fieldData.show_hint;
              this.fieldEditData.decimals = fieldData.decimals;
              this.fieldEditData.defaultValue = fieldData.default_value;
              this.fieldEditData.mask = fieldData.mask;
              this.fieldEditData.hint = fieldData.hint;
              this.fieldEditData.length = fieldData.length;
              this.fieldEditData.columnsOnForm = fieldData.columns_on_form;
              this.fieldEditData.rowsOnForm = fieldData.rows_on_form;
              this.fieldEditData.minValue = fieldData.min_value;
              this.fieldEditData.maxValue = fieldData.max_value;
              this.fieldEditData.quickCreate = fieldData.quick_create;
              this.fieldEditData.massEdit = fieldData.mass_edit;
              this.fieldEditData.showIcon = fieldData.show_icon;
              this.fieldEditData.unique = fieldData.unique;
              this.fieldEditData.mandatory = fieldData.mandatory;
              this.fieldEditData.entireLine = fieldData.entire_line;
              this.fieldEditData.showProgressBar = fieldData.show_progress_bar;
              this.fieldEditData.secret = fieldData.secret;
              this.fieldEditData.options = fieldData.options;
              this.fieldEditData.relatedTab = fieldData.has_related_tab;
              this.fieldEditData.relatedTabName = fieldData.related_tab_name;
              this.fieldEditData.relatedTabNameEn = fieldData.related_tab_name_en || '';
              this.fieldEditData.callApi = fieldData.call_api;
              this.fieldEditData.minimalTimeout = fieldData.minimal_timeout;
              this.fieldEditData.isDisabled = fieldData.is_disabled;
              this.fieldEditData.isSearchField = fieldData.is_search_field;
              this.fieldEditData.saveMask = fieldData.save_mask;
              this.fieldEditData.concatIdentifier = fieldData.concat_identifier;
              this.fieldEditData.allowPastDates = fieldData.allow_past_dates;
              this.fieldEditData.documentNameField =
                fieldData.document_name_field;

              if (fieldData.related_picklist_field !== null) {
                this.fieldEditData.picklistField =
                  fieldData.related_picklist_field;
              }

              if (fieldData.related_picklist_item !== null) {
                this.fieldEditData.picklistItem =
                  fieldData.related_picklist_item;
              }

              if (
                this.fieldEditData.type.id === 25 ||
                this.fieldEditData.type.id === 33
              ) {
                this.fieldEditData.relatedModule = fieldData.related_module;

                this.onFieldEditTypeChange(typeObject);
                this.onRelatedModuleEditChange(fieldData.related_module);

                this.fieldEditData.relatedField =
                  fieldData.related_module_field;
                if (
                  fieldData.related_parent !== null &&
                  fieldData.related_parent !== undefined
                ) {
                  this.fieldEditData.dependentField = fieldData.related_parent;
                }
              } else if (fieldData.type_id === 30) {
                this.onFieldEditTypeChange(typeObject);

                this.fieldEditData.relatedKanban = fieldData.related_module;
                this.fieldEditData.kanbanTitle = fieldData.kanban_title_field;
                this.fieldEditData.kanbanDescription =
                  fieldData.kanban_description_field;
              } else if (fieldData.type_id === 12) {
                let minValueFormatted = "";
                let maxValueFormatted = "";

                if (fieldData.min_value) {
                  minValueFormatted = `${fieldData.min_value.split("-")[2]}/${fieldData.min_value.split("-")[1]
                    }/${fieldData.min_value.split("-")[0]}`;
                }

                if (fieldData.max_value) {
                  maxValueFormatted = `${fieldData.max_value.split("-")[2]}/${fieldData.max_value.split("-")[1]
                    }/${fieldData.max_value.split("-")[0]}`;
                }

                this.fieldEditData.minValueDate = minValueFormatted;
                this.fieldEditData.maxValueDate = maxValueFormatted;
              } else if (fieldData.type_id == 13) {
                let minValueFormatted = "";
                let maxValueFormatted = "";

                if (fieldData.min_value) {
                  minValueFormatted = `${fieldData.min_value
                    .split(" ")[0]
                    .trim()
                    .split("-")[2]
                    }/${fieldData.min_value.split(" ")[0].split("-")[1]}/${fieldData.min_value.split(" ")[0].split("-")[0]
                    } ${fieldData.min_value.split(" ")[1]}`;
                }

                if (fieldData.max_value) {
                  maxValueFormatted = `${fieldData.max_value.split(" ")[0].split("-")[2]
                    }/${fieldData.max_value.split(" ")[0].split("-")[1]}/${fieldData.max_value.split(" ")[0].split("-")[0]
                    } ${fieldData.max_value.split(" ")[1]}`;
                }

                this.fieldEditData.minValueDateTime = minValueFormatted;
                this.fieldEditData.maxValueDateTime = maxValueFormatted;
              } else if (fieldData.type_id == 2) {
                this.fieldEditData.minValueInt = fieldData.min_value;
                this.fieldEditData.maxValueInt = fieldData.max_value;
              }

              const clearedRoles = [];

              this.roleList.forEach(item => {
                if (Object.keys(fieldData.permissions).includes(item.hash)) {
                  clearedRoles.push(item);
                }
              });

              const data = [];

              let i,
                j,
                temparray,
                chunk = 3;

              for (i = 0, j = clearedRoles.length; i < j; i += chunk) {
                temparray = clearedRoles.slice(i, i + chunk);

                data.push(temparray);
              }

              this.roleListSlicedEdit = data;

              setTimeout(() => {
                Object.keys(fieldData.permissions).forEach(item => {
                  const roleHash = item;

                  if (
                    fieldData.permissions[roleHash].can_edit &&
                    fieldData.permissions[roleHash].visible
                  ) {
                    this.rolePermissionsEdit[roleHash] = 2;
                    this.sliderEditChange(roleHash, 2);
                  } else if (
                    !fieldData.permissions[roleHash].can_edit &&
                    fieldData.permissions[roleHash].visible
                  ) {
                    this.rolePermissionsEdit[roleHash] = 1;
                    this.sliderEditChange(roleHash, 1);
                  } else {
                    this.rolePermissionsEdit[roleHash] = 0;
                    this.sliderEditChange(roleHash, 0);
                  }
                });
              }, 300);

              this.editFieldPopUpActive = true;

              this.$vs.loading.close();
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          throw new Error(e.message);
        });
    },
    deleteBlockConfirm(elementHash) {
      const block = document.querySelector(`#block-${elementHash}`);

      const fields = block
        .querySelector(".vx-card")
        .querySelector(
          ".vx-card__collapsible-content.vs-con-loading__container"
        )
        .querySelector(".vx-card__body").children[0].children;

      if (fields.length > 0) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.blockContainsFields"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      } else if (this.unsavedLayout) {
        this.$vs.notify({
          title: this.$t("MODULES.hashInvalidTitle"),
          text: this.$t("MODULES.saveLayoutChanges"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      } else {
        this.currentBlockToDelete = elementHash;

        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: this.$t("MODULES.confirmDeletionTitle"),
          text: this.$t("MODULES.confirmBlockDeletion"),
          accept: this.deleteBlock,
          acceptText: this.$t("MODULES.Delete")
        });
      }
    },
    async deleteBlock() {
      this.$vs.loading({ type: "default" });

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_delete_application_module_block",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          block_token: this.currentBlockToDelete
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.currentBlockToDelete = "";

            this.$vs.loading.close();

            await this.loadData();

            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: this.$t("MODULEs.blockDeleted"),
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          throw new Error(e.message);
        });
    },
    deleteFieldConfirm(elementHash) {
      this.currentFieldToDelete = elementHash;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("MODULES.confirmDeletionTitle"),
        text: this.$t("MODULES.confirmFieldDeletion"),
        accept: this.deleteField,
        acceptText: this.$t("MODULES.Delete")
      });
    },
    async deleteField() {
      this.$vs.loading({ type: "default" });

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_delete_application_module_field",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          field_token: this.currentFieldToDelete
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.currentFieldToDelete = "";

            this.$vs.loading.close();

            await this.loadData();

            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: this.$t("MODULES.fieldDeletedSuccessfully"),
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.FailedOperation"),
              text: this.$t("MODULES.fieldDeletionError"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.fieldDeletionError"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    resetNewFieldForm() {
      this.fieldData.name = "";
      this.fieldData.subtitle = null;
      this.fieldData.placeholder = null;
      this.fieldData.defaultValue = null;
      this.fieldData.showHint = false;
      this.fieldData.decimals = 2;
      this.fieldData.hint = null;
      this.fieldData.length = null;
      this.fieldData.columnsOnForm = 1;
      this.fieldData.rowsOnForm = null;
      this.fieldData.minValue = null;
      this.fieldData.maxValue = null;
      this.fieldData.minValueInt = null;
      this.fieldData.maxValueInt = null;
      this.fieldData.minValueDate = null;
      this.fieldData.maxValueDate = null;
      this.fieldData.minValueDateTime = null;
      this.fieldData.maxValueDateTime = null;
      this.fieldData.mask = null;
      this.fieldData.quickCreate = false;
      this.fieldData.massEdit = false;
      this.fieldData.showIcon = false;
      this.fieldData.mandatory = false;
      this.fieldData.entireLine = false;
      this.fieldData.relatedTab = false;
      this.fieldData.unique = false;
      this.fieldData.secret = false;
      this.fieldData.showProgressBar = false;
      this.fieldData.moduleOptions = [];
      this.fieldData.moduleFieldOptions = [];
      this.fieldData.relatedModule = {};
      this.fieldData.relatedField = {};
      this.fieldData.secret = false;
      this.fieldData.type = { id: 0, name: "" };
      this.fieldData.options = [];
      this.fieldData.picklistField = {};
      this.fieldData.picklistItem = {};
      this.fieldData.callApi = false;
      this.fieldData.minimalTimeout = 3;
      this.fieldData.showFooter = false;
      this.fieldData.picklistFieldItemsOptions = {};
      this.fieldData.picklistField = {};
      this.fieldData.isDisabled = false;
      this.fieldData.isSearchField = false;
      this.fieldData.matchPattern = false;
      this.fieldData.allowPastDates = true;
      this.fieldData.dependentField = {};
    },
    resetEditFieldForm() {
      this.fieldEditData.options = [];
      this.fieldEditData.relatedTab = false;
      this.fieldEditData.moduleOptions = [];
      this.fieldEditData.moduleFieldOptions = [];
      this.fieldEditData.showProgressBar = false;
      this.fieldEditData.relatedModule = {};
      this.fieldEditData.relatedField = {};
      this.fieldEditData.disableAll = true;
      this.fieldEditData.type = { id: 0, name: "" };
      this.fieldEditData.name = "";
      this.fieldEditData.subtitle = null;
      this.fieldEditData.placeholder = null;
      this.fieldEditData.defaultValue = null;
      this.fieldEditData.showHint = false;
      this.fieldEditData.decimals = 2;
      this.fieldEditData.hint = null;
      this.fieldEditData.length = null;
      this.fieldEditData.mask = null;
      this.fieldEditData.columnsOnForm = 1;
      this.fieldEditData.rowsOnForm = null;
      this.fieldEditData.minValue = null;
      this.fieldEditData.maxValue = null;
      this.fieldEditData.minValueInt = null;
      this.fieldEditData.maxValueInt = null;
      this.fieldEditData.minValueDate = null;
      this.fieldEditData.maxValueDate = null;
      this.fieldEditData.minValueDateTime = null;
      this.fieldEditData.maxValueDateTime = null;
      this.fieldEditData.quickCreate = false;
      this.fieldEditData.massEdit = false;
      this.fieldEditData.showIcon = false;
      this.fieldEditData.mandatory = false;
      this.fieldEditData.entireLine = false;
      this.fieldEditData.unique = false;
      this.fieldEditData.secret = false;
      this.fieldEditData.picklistField = {};
      this.fieldEditData.picklistItem = {};
      this.fieldEditData.callApi = false;
      this.fieldEditData.minimalTimeout = 3;
      this.fieldEditData.showFooter = false;
      this.fieldEditData.picklistFieldItemsOptions = {};
      this.fieldEditData.picklistField = {};
      this.fieldEditData.isDisabled = false;
      this.fieldEditData.isSearchField = false;
      this.fieldEditData.documentNameField = {};
      this.fieldEditData.allowPastDates = true;
      this.fieldEditData.dependentField = {};
    },
    async editFormSubmitted() {
      this.$vs.loading({ type: "default" });

      const permissionObject = {};

      Object.keys(this.rolePermissionsEdit).forEach(item => {
        if (this.rolePermissionsEdit[item] === 2) {
          permissionObject[item] = {
            visible: true,
            can_edit: true
          };
        } else if (this.rolePermissionsEdit[item] === 1) {
          permissionObject[item] = {
            visible: true,
            can_edit: false
          };
        } else {
          permissionObject[item] = {
            visible: false,
            can_edit: false
          };
        }
      });

      let relatedModuleHash = null;

      if (
        this.fieldEditData.type.id === 25 ||
        this.fieldEditData.type.id === 33
      ) {
        relatedModuleHash =
          Object.keys(this.fieldEditData.relatedModule).length === 0 &&
            this.fieldEditData.relatedModule.constructor === Object
            ? null
            : this.fieldEditData.relatedModule.hash;
      } else if (this.fieldEditData.type.id === 31) {
        relatedModuleHash =
          Object.keys(this.fieldEditData.relatedItemsModule).length === 0 &&
            this.fieldEditData.relatedItemsModule.constructor === Object
            ? null
            : this.fieldEditData.relatedItemsModule.hash;
      }

      const fieldBody = {
        hash: this.fieldEditData.hash,
        save_mask: this.fieldEditData.saveMask,
        concat_identifier: this.fieldEditData.concatIdentifier,
        name: this.fieldEditData.name,
        subtitle: this.fieldEditData.subtitle,
        type_id: this.fieldEditData.type.id,
        columns_on_form: this.fieldEditData.columnsOnForm,
        rows_on_form: this.fieldEditData.rowsOnForm,
        show_hint: this.fieldEditData.showHint,
        hint: this.fieldEditData.hint,
        placeholder: this.fieldEditData.placeholder,
        min_value: this.fieldEditData.minValue,
        max_value: this.fieldEditData.maxValue,
        default_value: this.fieldEditData.defaultValue,
        decimals: this.fieldEditData.decimals,
        mask: this.fieldEditData.mask,
        length: this.fieldEditData.length,
        quick_create: this.fieldEditData.quickCreate,
        mass_edit: this.fieldEditData.massEdit,
        show_icon: this.fieldEditData.showIcon,
        mandatory: this.fieldEditData.mandatory,
        entire_line: this.fieldEditData.entireLine,
        secret: this.fieldEditData.secret,
        unique: this.fieldEditData.unique,
        show_footer: this.fieldEditData.showFooter,
        show_progress_bar: this.fieldEditData.showProgressBar,
        allow_past_dates: this.fieldEditData.allowPastDates,
        permissions: permissionObject,
        related_module_field_hash:
          Object.keys(this.fieldEditData.relatedField).length === 0 &&
            this.fieldEditData.relatedField.constructor === Object
            ? null
            : this.fieldEditData.relatedField.hash,
        has_related_tab: this.fieldEditData.relatedTab,
        options: this.fieldEditData.options,
        dependent_field:
          this.fieldEditData.dependentField !== null
            ? this.fieldEditData.dependentField.hash
            : null,
        related_tab_name:
          this.fieldEditData.relatedTabName !== null
            ? this.fieldEditData.relatedTabName
            : null,
        related_tab_name_en:
          this.fieldEditData.relatedTabNameEn !== null && this.fieldEditData.relatedTabNameEn !== ''
            ? this.fieldEditData.relatedTabNameEn
            : null,
        kanban_title_hash:
          Object.keys(this.fieldEditData.kanbanTitle).length === 0 &&
            this.fieldEditData.kanbanTitle.constructor === Object
            ? null
            : this.fieldEditData.kanbanTitle.hash,
        kanban_description_hash:
          Object.keys(this.fieldEditData.kanbanDescription).length === 0 &&
            this.fieldEditData.kanbanDescription.constructor === Object
            ? null
            : this.fieldEditData.kanbanDescription.hash,
        call_api: this.fieldEditData.callApi,
        minimal_timeout: this.fieldEditData.minimalTimeout,
        related_picklist_field:
          JSON.stringify(this.fieldEditData.picklistField) === "{}" ||
            this.fieldEditData.picklistField === null
            ? null
            : this.fieldEditData.picklistField.hash,
        related_picklist_item:
          JSON.stringify(this.fieldEditData.picklistItem) === "{}" ||
            this.fieldEditData.picklistItem === null
            ? null
            : this.fieldEditData.picklistItem.hash,
        is_disabled: this.fieldEditData.isDisabled,
        is_search_field: this.fieldEditData.isSearchField,
        document_name_field:
          JSON.stringify(this.fieldEditData.documentNameField) === "{}" ||
            this.fieldEditData.documentNameField === undefined
            ? null
            : this.fieldEditData.documentNameField.hash
      };

      if (this.fieldEditData.type.id === 30) {
        fieldBody["related_module_hash"] =
          Object.keys(this.fieldEditData.relatedKanban).length === 0 &&
            this.fieldEditData.relatedKanban.constructor === Object
            ? null
            : this.fieldEditData.relatedKanban.hash;
      } else {
        fieldBody["related_module_hash"] = relatedModuleHash;
      }

      fieldBody["custom_display"] = this.fieldEditData.customDisplay
      fieldBody["display_location"] = Object.keys(this.fieldEditData.displayLocation).length > 0 ? this.fieldEditData.displayLocation.value : null


      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_update_application_module_field",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          block_token: this.currentBlockToEditField,
          field: fieldBody
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.$vs.loading.close();

            this.editFieldPopUpActive = false;
            this.currentBlockToEditField = null;

            await this.loadData();

            this.$vs.notify({
              title: this.$t("MODULES.operationCompletedTitle"),
              text: this.$t("MODULES.fieldUpdateSuccess"),
              iconPack: "feather",
              icon: "icon-check",
              color: "success"
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else if (response.status === 400) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("MODULES.hashInvalidTitle"),
              text: this.$t("MODULES.duplicateFieldName"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });
            this.showEmptyDataMessage = !this.showEmptyDataMessage;
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.showEmptyDataMessage = !this.showEmptyDataMessage;
          this.$vs.notify({
            title: this.$t("MODULES.FailedOperation"),
            text: this.$t("MODULES.fieldUpdateError"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },

    addButtonClicked(elementHash) {
      this.currentBlockToAddField = elementHash;
      this.addFieldPopUpActive = true;
      document
        .querySelectorAll(".wizard-nav.wizard-nav-pills")[1]
        .querySelectorAll("li")[0]
        .click();
    },
    async loadData() {
      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_get_application_module_fields",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(async responseData => {
              this.fieldsListToKanban = [];
              this.fieldsListToDocumentName = [];
              this.integratedKanbans = [];
              this.fieldData.picklistFieldOptions = [];
              this.fieldEditData.picklistFieldOptions = [];

              this.moduleInfo["name"] = responseData.module.name;

              if (responseData.module.payload.length > 0) {
                this.blockData = responseData.module.payload;

                this.blockData.sort((a, b) => {
                  if (a.index < b.index) return -1;
                  if (a.index < b.index) return 1;
                  return 0;
                });

                this.blockData.map((item, key) => {
                  this.$set(this.blockObject, item.hash, {
                    collapsed: item.collapsed,
                    visible: item.visible,
                    title: item.title,
                    hash: item.hash,
                    relatedPicklist: item.related_picklist,
                    relatedPicklistItem: item.related_picklist_item,
                    showOnAdd: item.show_on_add,
                    contentType: item.content_type,
                    requireIframeSubmitReady: item.require_iframe_submit_ready === true,
                    roles: Array.isArray(item.roles) ? item.roles : []
                  });

                  item.fields.forEach(fieldItem => {
                    if (
                      (fieldItem.type_id === 24 || fieldItem.type_id === 32) &&
                      !fieldItem.core
                    ) {
                      this.fieldData.picklistFieldOptions.push({
                        hash: fieldItem.hash,
                        name: fieldItem.title
                      });

                      this.fieldEditData.picklistFieldOptions.push({
                        hash: fieldItem.hash,
                        name: fieldItem.title
                      });

                      const listFieldOptions = [];

                      fieldItem.options.sort((a, b) => {
                        if (a.index < b.index) return -1;
                        if (a.index < b.index) return 1;
                        return 0;
                      });

                      fieldItem.options.forEach(fieldOptionItem => {
                        // console.log('fieldOptionItem')
                        // console.log(fieldOptionItem);

                        listFieldOptions.push({
                          hash: fieldOptionItem.value,
                          name: fieldOptionItem.label
                        });
                      });

                      this.$set(
                        this.fieldData.picklistFieldItemsOptions,
                        fieldItem.hash,
                        listFieldOptions
                      );
                      this.$set(
                        this.fieldEditData.picklistFieldItemsOptions,
                        fieldItem.hash,
                        listFieldOptions
                      );
                    }

                    if (
                      ![21, 22, 23, 27, 28].includes(fieldItem.type_id) &&
                      !fieldItem.core
                    ) {
                      this.fieldsListToKanban.push({
                        hash: fieldItem.hash,
                        name: fieldItem.title
                      });
                    }

                    if (fieldItem.type_id === 1 && !fieldItem.core) {
                      this.fieldsListToDocumentName.push({
                        hash: fieldItem.hash,
                        name: fieldItem.title
                      });
                    }

                    if (fieldItem.type_id === 30) {
                      this.integratedKanbans.push(
                        fieldItem.related_module.hash
                      );
                    }
                  });

                  item.fields.sort((a, b) => {
                    if (a.index < b.index) return -1;
                    if (a.index < b.index) return 1;
                    return 0;
                  });
                });
              }
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          throw new Error(e.message);
        });

      await performFetch(this.$store.state.auth.api_url, {
        command: "module_management_add_application_module_field_parameters",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash
        }
      })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(async responseData => {
              this.fieldData.typeOptions = responseData.parameters.field_types;

              this.moduleColumnsOnForm = responseData.parameters.columns_on_form;

              this.fieldData.columnsOnFormOptions = Array.from({ length: responseData.parameters.columns_on_form }).map((_, key) => key + 1)
              this.fieldEditData.columnsOnFormOptions = Array.from({ length: responseData.parameters.columns_on_form }).map((_, key) => key + 1)

              this.picklistFields = responseData.parameters.picklist_fields;
              this.picklistFieldItems = responseData.parameters.picklist_fields_items;

              this.roleList = responseData.parameters.roles;

              const data = [];

              let i,
                j,
                temparray,
                chunk = 3;

              for (i = 0, j = this.roleList.length; i < j; i += chunk) {
                temparray = this.roleList.slice(i, i + chunk);

                data.push(temparray);
              }

              this.roleListSliced = data;

              responseData.parameters.roles.forEach(item => {
                this.$set(this.rolePermissions, item.hash, 2);
                this.$set(this.rolePermissionsEdit, item.hash, 2);
                setTimeout(() => {
                  this.sliderChange(item.hash, 2);
                }, 300);
              });
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          throw new Error(e.message);
        });
    },
    dropItem(event) {

      this.invalidLayout = false;

      for (const item of document.querySelectorAll(".is-block")) {
        const blockFields = [];

        item
          .querySelector(".vx-card")
          .querySelector(
            ".vx-card__collapsible-content.vs-con-loading__container"
          )
          .querySelector(".vx-card__body")
          .children[0].children.forEach((fieldItem, fieldKey) => {
            const fieldName = fieldItem.querySelector('.is-field').querySelector('.vx-card__header .vx-card__title h4').innerText;

            blockFields.push(fieldName)
          });

        let hasDuplicates = new Set(blockFields).size !== blockFields.length;

        if (hasDuplicates) {
          this.invalidLayout = true;
          break
        }
      }

      if (this.invalidLayout) {
        return
      }

      // document.querySelectorAll(".is-block").forEach((item, key) => {

      // blockLayoutList.push(blockObject);
      // });

      this.unsavedLayout = true;
    },
    dragStart(event) {
      // console.log(event)
    },
    fieldColumn(columnsOnForm, entireLine, moduleColumns) {

      if (entireLine) {

        const width = (columnsOnForm / moduleColumns) * 100

        const marginRight = 100 - width

        return `width: ${width}%!important;margin-right: ${marginRight}%!important;`
      } else {
        const width = (columnsOnForm / moduleColumns) * 100

        return `width: ${width}%!important;`
      }

      // if (columnsOnForm === moduleColumns) {
      //   return 'vx-col w-full';
      // } else {
      //   return `vx-col w-${columnsOnForm}/${moduleColumns}`;
      // }

      // // if (entireLine) {
      // //   return "vx-col w-full";
      // // } else {
      // //   const fraction = columnsOnForm / moduleColumns;
      // //   // const percentageClass = fraction === 1 ? 'w-full' : `w-${Math.round(fraction * 12)}/12`;
      // //   const percentageClass = fraction === 1 ? 'w-full' : `w-${Math.round(fraction * 12)}/12`;
      // //   return `vx-col ${percentageClass}`;
      // // }

      // if (entireLine) {
      //   return "vx-col w-full";
      // } else if (this.max_columns === 1) {
      //   return "vx-col w-full";
      // } else if (this.max_columns === 2) {
      //   if (columnsOnForm === 1) {
      //     return "vx-col w-full md:w-1/2";
      //   } else {
      //     return "vx-col w-full";
      //   }
      // } else if (this.max_columns === 3) {
      //   if (columnsOnForm === 1) {
      //     return "vx-col w-full md:w-1/3";
      //   } else if (columnsOnForm === 2) {
      //     return "vx-col w-full md:w-2/3";
      //   } else {
      //     return "vx-col w-full";
      //   }
      // } else if (columnsOnForm === 1) {
      //   return "vx-col w-full md:w-1/4";
      // } else if (columnsOnForm === 2) {
      //   return "vx-col w-full md:w-1/2";
      // } else if (columnsOnForm === 3) {
      //   return "vx-col w-full md:w-3/4";
      // } else {
      //   return "vx-col w-full";
      // }
    }
  },
  async mounted() {
    document.title = `${document.title.split(" | ")[0]} | Campos`;

    this.$vs.loading({
      type: "default"
    });

    await this.loadData();

    setTimeout(() => {
      document.querySelectorAll(".vx-card__body")[0].style.padding = "0.75rem";
    }, 300)
  },
  async created() {

  }
};
</script>

<style scoped>
.con-vs-popup>>>.vs-popup {
  width: 1000px !important;
  height: auto !important;
}

.vx-row {
  transition: all 1s;
}

.field-type-select>>>.vs__dropdown-menu {
  height: 168px !important;
}

.vs-con-table>>>.vs-con-tbody {
  background: #ffffff !important;
}

.vs-slider--circles.isEndValue {
  border-radius: 50% !important;
}

/* div.con-vs-chip {
  min-height: 20px!important;
  min-width: 0px!important;
  font-size: .6rem;
} */
</style>
